import { useEffect } from "react";

/**
 * Global admin keyboard shortcuts:
 * - "/" focuses an input with id="admin-search"
 * - "Esc" handled per-modal (we just allow native dialog Escape via shadcn)
 */
export default function useAdminShortcuts() {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "/" && document.activeElement?.tagName !== "INPUT" && document.activeElement?.tagName !== "TEXTAREA") {
        const el = document.getElementById("admin-search");
        if (el) {
          e.preventDefault();
          el.focus();
        }
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);
}
